import React from 'react';
import { 
  TrendingUp, 
  Scale, 
  Building2, 
  Briefcase, 
  Users, 
  ArrowRight 
} from 'lucide-react';
import './ServicesPage.css';
import Navbar from '../LandingPage/Navbar';
import Footer from '../LandingPage/Footer';

const SERVICES_DATA = [
  {
    id: 1,
    title: "Investment Advisory",
    desc: "Strategic real estate investment planning to maximize returns and build generational wealth.",
    icon: <TrendingUp size={28} />
  },
  {
    id: 2,
    title: "Legal Vetting",
    desc: "Comprehensive documentation support and legal due diligence for zero-risk transactions.",
    icon: <Scale size={28} />
  },
  {
    id: 3,
    title: "Portfolio Management",
    desc: "End-to-end assistance in property resale, asset management, and portfolio diversification.",
    icon: <Building2 size={28} />
  },
  {
    id: 4,
    title: "Financial Planning",
    desc: "Expert financial structuring specifically tailored for high-value realty investments.",
    icon: <Briefcase size={28} />
  },
  {
    id: 5,
    title: "Client Consultations",
    desc: "Transparent, client-first advisory focusing on long-term partnerships rather than just sales.",
    icon: <Users size={28} />
  }
];




const ServicesPage = () => {
  return (
    <>
       <Navbar/>
       {/* Hero Section */}
<section className="hero-section1">
  <div className="hero-content1">
    <h1 className="hero-title1">Premium Real Estate Services</h1>
    <p className="hero-subtitle1">
      We provide expert investment, legal, and financial advisory tailored to your real estate ambitions.
    </p>
  </div>
</section>
    <section className="premium-services" id="services">
      {/* Background Decor */}
      <div className="bg-decor-circle"></div>

      <div className="container relative-z">
        
    

        {/* Services Grid */}
        <div className="services-grid">
          {SERVICES_DATA.map((service) => (
            <div className="service-card" key={service.id}>
              <div className="card-inner">
                
                {/* Icon Header */}
                <div className="icon-header">
                  <div className="s-icon-box">
                    {service.icon}
                  </div>
                  <span className="s-id">0{service.id}</span>
                </div>

                {/* Content */}
                <h3 className="s-title">{service.title}</h3>
                <p className="s-desc">{service.desc}</p>

                {/* Hover Action */}
                <div className="s-link">
                  <span>Learn More</span>
                  <ArrowRight size={16} className="arrow-icon" />
                </div>

                {/* Decorative Hover Gradient */}
                <div className="hover-gradient-border"></div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
    <Footer/>
     </>
  );
};

export default ServicesPage;